import { render, staticRenderFns } from "./DemosList.vue?vue&type=template&id=10022463&scoped=true&"
import script from "./DemosList.vue?vue&type=script&lang=js&"
export * from "./DemosList.vue?vue&type=script&lang=js&"
import style0 from "./DemosList.vue?vue&type=style&index=0&id=10022463&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10022463",
  null
  
)

component.options.__file = "DemosList.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardTitle,
  VDataTable,
  VIcon,
  VProgressLinear,
  VSpacer,
  VTextField,
})
